import React from "react";
import { MyTooltip } from "../common/MyTooltip";
import ManageResourcesMenu from "./ManageResourcesMenu";
import { Logs } from "lucide-react";
import config from "environment";
interface ResourceActionsProps {
  isEmbedded: boolean;
  tooltip: string;
  onOpen: () => void;
  onDelete: () => void;
  onFolderDelete?: () => void;
  folderName: string | null;
  fileCount?: number;
  openResourceActionSidebar: () => void;
}

export const ResourceActions = ({
  isEmbedded,
  tooltip,
  onOpen,
  onDelete,
  onFolderDelete,
  folderName,
  fileCount,
  openResourceActionSidebar,
}: ResourceActionsProps) => {
  return (
    <div className="collection-resources-right">
      <MyTooltip
        title={
          <span style={{ color: "var(--text-color-primary" }}>{tooltip}</span>
        }>
        <div className="collection-resources-embedded">
          {isEmbedded ? (
            <img src="/icons/winslow-ai-logo.svg" alt="" />
          ) : (
            <img src="/icons/alert.svg" alt="" />
          )}
        </div>
      </MyTooltip>
      <div className="collection-resources-open" onClick={onOpen}>
        <img src="/icons/light-mode/external_grey.svg" alt="" />
      </div>
      <div className="collection-resources-delete" onClick={onDelete}>
        <img src="/icons/trash.svg" alt="" />
      </div>
      {/* {onFolderDelete && folderName ? (
        <div className="collection-resources-menu">
          <ManageResourcesMenu
            onDelete={onFolderDelete}
            folderName={folderName}
            fileCount={fileCount || 0}
          />
        </div>
      ) : (
        <div className="collection-resources-menu"></div>
      )} */}
      {config.showLinkRecordLogs && (
        <div
          className="collection-resources-action-log"
          onClick={openResourceActionSidebar}>
          <Logs />
        </div>
      )}
    </div>
  );
};
